import { useCallback, useEffect, useState } from 'react';
import { fetchPartOrderLines } from '../services/partOrdersApi';
import { useSignalREvent } from './useSignalR';

// Derives the basket count from the lines list (shared with the dashboard's
// usePartOrderLinesByWorkitem hook via in-flight dedupe in partOrdersApi).
export function usePartsToOrderCount(): number {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const lines = await fetchPartOrderLines({});
      setCount(lines.filter(l => l.status === 'to_order').length);
    } catch {
      // Non-essential nav indicator; silent failure is fine.
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useSignalREvent('parts:to_order', () => refresh());
  useSignalREvent('parts:order_placed', () => refresh());

  return count;
}
